import { Box, Drawer } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { DrawerRowAnchor, DrawerText, ListMobileAnchor, LogoDrawer } from './common';
import ArrowRight from '@mui/icons-material/KeyboardArrowRight';

const MobileDrawer = ({ setDrawerState, drawerState }) => (
  <Drawer
    PaperProps={{
      sx: {
        width: '100%',
        backgroundColor: '#274bde',
        color: '#fff',
        fontSize: 18,
      },
    }}
    anchor="right"
    open={drawerState}
    onClose={() => setDrawerState(false)}
  >
    <Box
      sx={{
        p: 2,
        height: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 1,
        }}
      >
        <IconButton onClick={() => setDrawerState(false)}>
          <CloseIcon htmlColor={'#fff'} />
        </IconButton>
        <Box
          sx={{
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
          }}
        >
          <a href={'/'}>
            <LogoDrawer>Pixels.AI</LogoDrawer>
          </a>
        </Box>
      </Box>
      <DrawerRowAnchor className={'initial'}>
        <ListMobileAnchor href={'/login/'}>
          <DrawerText
            primary="Login"
            primaryTypographyProps={{
              fontFamily: 'ProximaNovaSemiBold',
            }}
          />
          <ArrowRight />
        </ListMobileAnchor>
      </DrawerRowAnchor>
    </Box>
  </Drawer>
);

export default MobileDrawer;
